var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WalletMultiButton',{attrs:{"openOnboardingUrls":false,"connecting":_vm.connecting,"wallets":_vm.custom_wallets,"auto-connect":false,"featured":3,"dark":""},on:{"copy":_vm.onCopy,"error":_vm.onWalletError,"connect":_vm.onConnect,"disconnect":_vm.onDisconnect}})
}
var staticRenderFns = []

export { render, staticRenderFns }